export default __webpack_public_path__ + "static/media/salesforce.11c2da3d.svg";